import { CancelTokenSource } from "axios";
import axios from "./http";
import {
  InterventionAvailabilityDto,
  InterventionAvailabilitySearchRequest,
  SlotDto,
  SlotSearchRequest,
  UpsertSlotDto
} from "ts-types/api.types";

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUrl = `${baseUrl}/api/slots`;

export const searchInterventionAvailabilities = (
    searchRequest: Partial<InterventionAvailabilitySearchRequest>, cancelToken: CancelTokenSource)
    : Promise<InterventionAvailabilityDto[]> => {

  return axios
      .post(`${baseUrl}/api/intervention-availability/search`,
          searchRequest,
          { cancelToken: cancelToken.token })
      .then(response => response.data);
}

export const searchSlots = (searchRequest: Partial<SlotSearchRequest>, cancelToken: CancelTokenSource): Promise<Array<SlotDto>> => {
  return axios
      .post(`${apiUrl}/search`, searchRequest, { cancelToken: cancelToken.token })
      .then(response => response.data);
}

export const getAllSlots = (cancelToken: CancelTokenSource): Promise<Array<SlotDto>> => {
  return axios
      .get(`${apiUrl}`, { cancelToken: cancelToken.token })
      .then(response => response.data);
}

export const getUpsertSlot = (id: number, cancelToken: CancelTokenSource): Promise<UpsertSlotDto> => {
  return axios
      .get(`${apiUrl}/${id}`, { cancelToken: cancelToken.token })
      .then(response => response.data);
}

// TODO ftrajkov 2021-05-13: Fix `any` type casting
export const activateSlot = (id: number, cancelToken: CancelTokenSource): Promise<any> => {
  return axios
      .get(`${apiUrl}/activate/${id}`, { cancelToken: cancelToken.token });
}

// TODO ftrajkov 2021-05-13: Fix `any` type casting
export const addSlot = (upsertSlotDto: UpsertSlotDto, cancelToken: CancelTokenSource): Promise<any> => {
  return axios
      .post(`${apiUrl}`, upsertSlotDto, { cancelToken: cancelToken.token });
}

// TODO ftrajkov 2021-05-13: Fix `any` type casting
export const editSlot = (id: number, upsertSlotDto: UpsertSlotDto, cancelToken: CancelTokenSource): Promise<any> => {
  return axios
      .put(`${apiUrl}/${id}`, upsertSlotDto, { cancelToken: cancelToken.token });
}

// TODO ftrajkov 2021-05-13: Fix `any` type casting
export const deleteSlot = (id: number, cancelToken: CancelTokenSource): Promise<any> => {
  return axios
      .delete(`${apiUrl}/${id}`, { cancelToken: cancelToken.token });
}
